import React from 'react'
import PropTypes from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import StarsRating from 'Pods/Shared/StarsRating'
import Icon from 'Pods/Shared/Icon/Icon'

function UserProjectsReviewRate({ type, score, locale }) {
  const positive =  i18n.t('profilePage.positive', { ns: 'rails', lng: locale })
  const negative =  i18n.t('profilePage.negative', { ns: 'rails', lng: locale })

  return (
    <span className="review-rate">
      {type === 'projectRatings' ? (
        <StarsRating
          rating={score}
          readonly
        />
      ) : (
        <span className="product-ratings__thumbs">
          {score > 0 ? (
            <p className="u-mb0">
              <span className="heading-14 text-green">{positive}:</span>
              <Icon type={['far', 'thumbs-up']} className="text-green u-ml10" />
            </p>
          ) : (
            <p className="u-mb0">
              <span className="heading-14 text-light-grey">{negative}:</span>
              <Icon type={['far', 'thumbs-down']} className="text-light-grey u-ml10" />
            </p>
          )}
        </span>
      )}
    </span>
  )
}

UserProjectsReviewRate.propTypes = {
  type: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
}

export default UserProjectsReviewRate
